/*
 * --------
 * Mainsite
 * --------
 */

/*
 * Constants defined client-side
 * (see Assets/Toyota/MainSite/js/ng/templates/constants.js for constants defined server-side)
 */

import "../../../../../../Feature/MainSite/code/Toyota.Feature.Forms.UI/Assets/Toyota/Forms/js/ng/templates/forms-constants.js";

/*
 * App
 */

import "../../Assets/Toyota/MainSite/js/ng/app.js";

/*
 * Factories
 */

import "../../Assets/Toyota/MainSite/js/ng/factories/addresses.js";
import "../../Assets/Toyota/MainSite/js/ng/factories/animations.js";
import "../../Assets/Toyota/MainSite/js/ng/factories/api.js";
import "../../Assets/Toyota/MainSite/js/ng/factories/css-media-watcher.js";
import "../../Assets/Toyota/MainSite/js/ng/factories/colour-service.js";
import "../../Assets/Toyota/MainSite/js/ng/factories/cookies.js";
import "../../Assets/Toyota/MainSite/js/ng/factories/dealer-inventory.js";
import "../../Assets/Toyota/MainSite/js/ng/factories/dealer.js";
import "../../Assets/Toyota/MainSite/js/ng/factories/disclaimers-service.js";
import "../../Assets/Toyota/MainSite/js/ng/factories/geodecode.js";
import "../../Assets/Toyota/MainSite/js/ng/factories/http-request-timeout-interceptor.js";
import "../../Assets/Toyota/MainSite/js/ng/factories/info-service.js";
import "../../Assets/Toyota/MainSite/js/ng/factories/localstorage.js";
import "../../Assets/Toyota/MainSite/js/ng/factories/sessionstorage.js";
import "../../Assets/Toyota/MainSite/js/ng/factories/location.js";
import "../../Assets/Toyota/MainSite/js/ng/factories/paint-list-colour-matcher.js";
import "../../Assets/Toyota/MainSite/js/ng/factories/postcodes.js";
import "../../Assets/Toyota/MainSite/js/ng/factories/region.js";
import "../../Assets/Toyota/MainSite/js/ng/factories/generate-uuid.js";
import "../../Assets/Toyota/MainSite/js/ng/factories/vehicle.js";
import "../../Assets/Toyota/MainSite/js/ng/factories/vin.js";

// Factories - Analytics
import "../../Assets/Toyota/MainSite/js/ng/factories/analytics/pricing-page-analytics.js";

// Factories - Range
import "../../Assets/Toyota/MainSite/js/ng/factories/range/range.js";
import "../../Assets/Toyota/MainSite/js/ng/factories/range/api/image.js";
import "../../Assets/Toyota/MainSite/js/ng/factories/range/api/paint.js";
import "../../Assets/Toyota/MainSite/js/ng/factories/range/api/prices.js";
import "../../Assets/Toyota/MainSite/js/ng/factories/range/api/trim.js";
import "../../Assets/Toyota/MainSite/js/ng/factories/range/api/variant.js";
import "../../Assets/Toyota/MainSite/js/ng/factories/range/sorting.js";

/*
 * Services
 */

import "../../Assets/Toyota/MainSite/js/ng/services/toast-manager.js";
import "../../Assets/Toyota/MainSite/js/ng/services/mouse-detection.js";
import "../../Assets/Toyota/MainSite/js/ng/services/global-breakpoints.js";
import "../../Assets/Toyota/MainSite/js/ng/services/scroll-lock.js";
import "../../Assets/Toyota/MainSite/js/ng/services/on-screen-debug-logger.js";
import "../../Assets/Toyota/MainSite/js/ng/services/custom-easings.js";
import "../../Assets/Toyota/MainSite/js/ng/services/debug-logger.js";
import "../../Assets/Toyota/MainSite/js/ng/services/pricing-send-to-dealer-autofill.js";
import "../../Assets/Toyota/MainSite/js/ng/services/url-parser.js";
import "../../Assets/Toyota/MainSite/js/ng/services/stick-to-top-manager.js";
import "../../Assets/Toyota/MainSite/js/ng/services/sitecore-analytics.js";
import "../../Assets/Toyota/MainSite/js/ng/services/modal-service.js";
import "../../Assets/Toyota/MainSite/js/ng/services/smooth-scroll-to.js";
import "../../Assets/Toyota/MainSite/js/ng/services/scroll-into-view.js";
import "../../Assets/Toyota/MainSite/js/ng/services/get-pseudo-element-content.js";
import "../../Assets/Toyota/MainSite/js/ng/services/parse-bool.js";
import "../../Assets/Toyota/MainSite/js/ng/services/page-options.js";
import "../../Assets/Toyota/MainSite/js/ng/services/location-manager.js";
import "../../Assets/Toyota/MainSite/js/ng/services/geolocation.js";
import "../../Assets/Toyota/MainSite/js/ng/services/toyota-for-you.js";
import "../../Assets/Toyota/MainSite/js/ng/services/dealer-selector.js";
import "../../Assets/Toyota/MainSite/js/ng/services/wishlist.js";
import "../../Assets/Toyota/MainSite/js/ng/services/custom-events.js";

/*
 * Filters
 */

import "../../Assets/Toyota/MainSite/js/ng/filters/filters.js";

/*
 * Components
 */

import "../../Assets/Toyota/MainSite/js/ng/components/loading-spinner.js";

/*
 * Directives
 */

import "../../Assets/Toyota/MainSite/js/ng/directives/accordion.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/api-error-message.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/cement-attribute.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/dealer-inventory.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/driveaway-price.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/driveaway-price-isolate-scope.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/expanding-field.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/geo-locate-search.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/jwplayer.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/location-change.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/maintain-height.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/modal.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/mouse-detected.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/mouse-detected-css.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/link-disabled.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/ng-infinite-scroll.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/lazy-load-img.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/number-animator.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/order-and-collect.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/post-repeat.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/richtext-analytics.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/richtext-add-new-vehicle-to-wishlist.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/add-new-vehicle-to-wishlist.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/add-to-wishlist-on-querystring.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/show-if-missing-src.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/stick-to-top.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/styleguide.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/swatches.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/svg-icon.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/tabs.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/textarea-autosize.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/toasts.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/tooltip-callout.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/tooltip-icon.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/lazysizes-fix.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/linked-expandos.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/deep-anchor-link.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/truncate-text.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/toggle-class.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/ui-select-options.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/scroll-top.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/ui-select-validate-vehicle-field.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/ui-select-simplebar.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/geolocation-permission-request.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/toyota-for-you.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/scrollbar-width-css-custom-prop.js";

// Directives - Body & Paint Repair
import "../../Assets/Toyota/MainSite/js/ng/directives/body-paint-repair/body-paint-repair.js";

// Directives - Content
import "../../Assets/Toyota/MainSite/js/ng/directives/content/fancy-accordion.js";

// Directives - Find a Dealer
import "../../Assets/Toyota/MainSite/js/ng/directives/find-a-dealer/find-a-dealer-page.js";

// Directives - Newsroom
import "../../Assets/Toyota/MainSite/js/ng/directives/newsroom/press-listing.js";

// Directives - Pricing page
import "../../Assets/Toyota/MainSite/js/ng/directives/pricing-page/pricing-cta.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/pricing-page/pricing-driveaway.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/pricing-page/pricing-grade-selector.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/pricing-page/pricing-grade-selector-item-driveaway.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/pricing-page/pricing-image.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/pricing-page/pricing-option-pack-selector.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/pricing-page/pricing-page.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/pricing-page/pricing-page-ui.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/pricing-page/pricing-paint-selector.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/pricing-page/pricing-trim-selector.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/pricing-page/pricing-variant-selector.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/pricing-page/pricing-offer-cta.js";

// Directives - Finance Calculator
import "../../Assets/Toyota/MainSite/js/ng/directives/finance/finance-options.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/finance/finance-calculator.js";

// Directives - Range Page
import "../../Assets/Toyota/MainSite/js/ng/directives/range-page/range-page.js";

// Directives - Range Spinner
import "../../Assets/Toyota/MainSite/js/ng/directives/range-spinner/range-spinner.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/range-spinner/range-spinner-grade-selector.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/range-spinner/range-spinner-paint-selector.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/range-spinner/range-spinner-cta.js";

// Directives - Service Pricing
import "../../Assets/Toyota/MainSite/js/ng/directives/service-pricing/service-pricing-tool.js";

// Directives - Test
import "../../Assets/Toyota/MainSite/js/ng/directives/test/test-driveaway-price.js";

// Directives - Vehicle Hub
import "../../Assets/Toyota/MainSite/js/ng/directives/vehicle-hub/accessories.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/vehicle-hub/disclaimers.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/vehicle-hub/disclaimer-ref.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/vehicle-hub/hero-info.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/vehicle-hub/owl-carousel.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/vehicle-hub/secondary-nav.js";
import "../../Assets/Toyota/MainSite/js/ng/directives/vehicle-hub/video-player.js";

/*
 * -----
 * Forms
 * -----
 */

/*
 * Factories
 */

import "../../../../../../Feature/MainSite/code/Toyota.Feature.Forms.UI/Assets/Toyota/Forms/js/ng/factories/dealers.js";
import "../../../../../../Feature/MainSite/code/Toyota.Feature.Forms.UI/Assets/Toyota/Forms/js/ng/factories/gtm-details.js";

/*
 * Directives
 */

import "../../../../../../Feature/MainSite/code/Toyota.Feature.Forms.UI/Assets/Toyota/Forms/js/ng/directives/book-a-service-osb-transform.js";
import "../../../../../../Feature/MainSite/code/Toyota.Feature.Forms.UI/Assets/Toyota/Forms/js/ng/directives/dealer-lookup.js";
import "../../../../../../Feature/MainSite/code/Toyota.Feature.Forms.UI/Assets/Toyota/Forms/js/ng/directives/valid-phone.js";
import "../../../../../../Feature/MainSite/code/Toyota.Feature.Forms.UI/Assets/Toyota/Forms/js/ng/directives/valid-rego.js";
import "../../../../../../Feature/MainSite/code/Toyota.Feature.Forms.UI/Assets/Toyota/Forms/js/ng/directives/numbers-only.js";
import "../../../../../../Feature/MainSite/code/Toyota.Feature.Forms.UI/Assets/Toyota/Forms/js/ng/directives/valid-email.js";
import "../../../../../../Feature/MainSite/code/Toyota.Feature.Forms.UI/Assets/Toyota/Forms/js/ng/directives/valid-postcode.js";
import "../../../../../../Feature/MainSite/code/Toyota.Feature.Forms.UI/Assets/Toyota/Forms/js/ng/directives/restrict-to-length.js";
import "../../../../../../Feature/MainSite/code/Toyota.Feature.Forms.UI/Assets/Toyota/Forms/js/ng/directives/scroll-to-error.js";
import "../../../../../../Feature/MainSite/code/Toyota.Feature.Forms.UI/Assets/Toyota/Forms/js/ng/directives/forms-book-a-test-drive.js";
import "../../../../../../Feature/MainSite/code/Toyota.Feature.Forms.UI/Assets/Toyota/Forms/js/ng/directives/query-string-to-scope.js";
import "../../../../../../Feature/MainSite/code/Toyota.Feature.Forms.UI/Assets/Toyota/Forms/js/ng/directives/year-selection.js";
import "../../../../../../Feature/MainSite/code/Toyota.Feature.Forms.UI/Assets/Toyota/Forms/js/ng/directives/address-autocomplete.js";
import "../../../../../../Feature/MainSite/code/Toyota.Feature.Forms.UI/Assets/Toyota/Forms/js/ng/directives/unique-vehicle.js";
import "../../../../../../Feature/MainSite/code/Toyota.Feature.Forms.UI/Assets/Toyota/Forms/js/ng/directives/forms-contact-a-dealer.js";
import "../../../../../../Feature/MainSite/code/Toyota.Feature.Forms.UI/Assets/Toyota/Forms/js/ng/directives/forms-register-my-interest.js";
import "../../../../../../Feature/MainSite/code/Toyota.Feature.Forms.UI/Assets/Toyota/Forms/js/ng/directives/forms-contact-us.js";
import "../../../../../../Feature/MainSite/code/Toyota.Feature.Forms.UI/Assets/Toyota/Forms/js/ng/directives/forms-contact-us-uplift.js";
import "../../../../../../Feature/MainSite/code/Toyota.Feature.Forms.UI/Assets/Toyota/Forms/js/ng/directives/forms-keep-me-informed.js";
import "../../../../../../Feature/MainSite/code/Toyota.Feature.Forms.UI/Assets/Toyota/Forms/js/ng/directives/forms-takata.js";
import "../../../../../../Feature/MainSite/code/Toyota.Feature.Forms.UI/Assets/Toyota/Forms/js/ng/directives/forms-change-ownership.js";
import "../../../../../../Feature/MainSite/code/Toyota.Feature.Forms.UI/Assets/Toyota/Forms/js/ng/directives/forms-book-a-service.js";
import "../../../../../../Feature/MainSite/code/Toyota.Feature.Forms.UI/Assets/Toyota/Forms/js/ng/directives/gtm-click.js";
import "../../../../../../Feature/MainSite/code/Toyota.Feature.Forms.UI/Assets/Toyota/Forms/js/ng/directives/gtm-form.js";
import "../../../../../../Feature/MainSite/code/Toyota.Feature.Forms.UI/Assets/Toyota/Forms/js/ng/directives/provide-pricing-send-to-dealer-analytics.js";
import "../../../../../../Feature/MainSite/code/Toyota.Feature.Forms.UI/Assets/Toyota/Forms/js/ng/directives/provide-form-field-analytics.js";
import "../../../../../../Feature/MainSite/code/Toyota.Feature.Forms.UI/Assets/Toyota/Forms/js/ng/directives/autocomplete-off.js";
import "../../../../../../Feature/MainSite/code/Toyota.Feature.Forms.UI/Assets/Toyota/Forms/js/ng/directives/valid-customer-number.js";
import "../../../../../../Feature/MainSite/code/Toyota.Feature.Forms.UI/Assets/Toyota/Forms/js/ng/directives/shown-validation.js";
import "../../../../../../Feature/MainSite/code/Toyota.Feature.Forms.UI/Assets/Toyota/Forms/js/ng/directives/clear-form-on-init.js";
/*
 * Legacy components - Accessories Gallery
 */

import "../../Assets/Toyota/MainSite/js/ng/legacy/gallery/gallery-module.js";
import "../../Assets/Toyota/MainSite/js/ng/legacy/gallery/gallery-page.js";
import "../../Assets/Toyota/MainSite/js/ng/legacy/gallery/link-to-slide.js";
